/* eslint-disable jsx-a11y/alt-text */
import { Grid, Typography, Box } from '@material-ui/core';
import React from 'react';
import { currencyFormatter, simpleDateFormatter } from '../Shared/colorFormat';
import './index.css';

export class CustomersRaseedPrint extends React.PureComponent<any, any> {
  renderItemHeaderTable = (isRTL: boolean) => {
    return (
      <tr style={{ fontSize: 12 }}>
        <th>{isRTL ? 'العميل' : 'Customer'}</th>
        <th>{isRTL ? 'رصيد اول الفترة' : 'Starting Balance'}</th>
        <th>{isRTL ? 'رصيد الفترة' : 'Period Balance'}</th>
        <th>{isRTL ? 'الرصيد الاجمالي' : 'Total Balance'}</th>
      </tr>
    );
  };
  renderItemTable = (item: any, isRTL: any) => {
    return (
      <tr style={{ fontSize: 12 }}>
        <td style={{ textAlign: 'center' }}>
          {isRTL ? item?.customerNameAr : item?.customerName}
        </td>
        <td>{currencyFormatter({ value: item?.oldraseed })}</td>
        <td>{currencyFormatter({ value: item?.nowraseed })}</td>
        <td>{currencyFormatter({ value: item?.allraseed })}</td>
      </tr>
    );
  };

  renderHeader = (company: any) => (
    <img
      src={company?.header}
      alt={company?.name}
      height="auto"
      width="100%"
      style={{
        objectFit: 'contain',
      }}
    />
  );

  renderFooter = (company: any) => (
    <img
      src={company?.footer}
      alt={company?.name}
      height="100%"
      width="100%"
      style={{ objectFit: 'contain' }}
    />
  );

  renderFrontTop = ({ isRTL, start, end }: any) => {
    return (
      <Grid container spacing={2}>
        <Grid item xs={2}>
          <Typography>التاريخ:</Typography>
        </Grid>
        <Grid item xs={2}>
          <Typography>{simpleDateFormatter(new Date())}</Typography>
        </Grid>
        <Grid item xs={8}></Grid>
        <Grid item xs={4}>
          <Typography variant="h5">
            {isRTL ? 'ارصدة العملاء' : 'Customers Balance'}{' '}
          </Typography>
        </Grid>
        <Grid item xs={8}></Grid>
        <Grid item xs={2}>
          <Typography style={{ fontSize: 16 }}>
            {simpleDateFormatter(start)}
          </Typography>
        </Grid>
        <Grid item xs={2}>
          <Typography style={{ fontSize: 16 }}>
            {simpleDateFormatter(end)}
          </Typography>
        </Grid>
        <Grid item xs={8}></Grid>
      </Grid>
    );
  };

  render() {
    const { start, end, company, items, isRTL } = this.props;

    return (
      <Box>
        <div className="header">{this.renderHeader(company)}</div>
        <Box
          style={{
            height: 170,
          }}
        ></Box>
        <div style={{ paddingLeft: 60, paddingRight: 40, direction: 'rtl' }}>
          <Box
            style={{
              height: 170,
              position: 'absolute',
              top: 170,
              width: '100%',
            }}
          >
            {this.renderFrontTop({ isRTL, start, end })}
          </Box>
          <table id="report" className="report-container">
            <thead className="report-header">
              <div className="header-space"></div>
              {this.renderItemHeaderTable(isRTL)}
            </thead>
            <tbody className="report-content">
              {items?.map((item: any) => this.renderItemTable(item, isRTL))}
            </tbody>
            <tfoot className="report-footer">
              <tr style={{ padding: 0, borderColor: '#fff', borderWidth: 0 }}>
                <td style={{ padding: 0, borderColor: '#fff', borderWidth: 0 }}>
                  <div className="footer-info">
                    <div
                      className="page-footer"
                      style={{ fontSize: 14, padding: 5 }}
                    >
                      {company?.name}
                    </div>
                  </div>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
        {/* <img alt={company?.name} src={company?.logo} className={'watermark'} /> */}
      </Box>
    );
  }
}
